/**
 * プロジェクトの一覧（ホーム）の上の「あなたあてのプロジェクトがあります」（2026-10-21 core/handoff-1a）。
 * WHY 要るか: 受け取る人（受託のクライアント）は招待のメールのリンクから来るとは限らない（メールを消した・別の端末でログインした）。
 *   ログインしたら最初に見るホームで気づけるようにする。中身（誰から・どのプロジェクト）は受け取りの画面（pages/TransferIncomingPage.tsx）。
 * 何も無いとき・読めないとき（古いサーバー = 404）は何も出さない（ホームの流れを邪魔しない）。名前は利用者の値 = テキストとして出す。
 */
import { Link } from 'react-router-dom';
import { useResource } from '../hooks';
import { useT } from '../i18n';
import { INCOMING_LIST_PATH, incomingPagePath, type TransferView } from '../projectTransfer';

type Incoming = TransferView & { project: { id: string; name: string }; from: { email: string } };

export function IncomingTransfers() {
  const { t } = useT();
  const list = useResource<{ incoming: Incoming[] }>(INCOMING_LIST_PATH);
  const items = list.data?.incoming ?? [];
  if (!items.length) return null;
  return (
    <section className="card" aria-live="polite">
      <h2 className="card-title">{t('transfer.banner.title')}</h2>
      <ul>
        {items.map((x) => (
          <li key={x.id}>
            {t('transfer.banner.item', { project: x.project.name, email: x.from.email })} <Link to={incomingPagePath(x.id)}>{t('transfer.banner.review')}</Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
